import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalHealthSystem } from '../../../core/model/v2/healthSystem/global-health-system';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { MatDialog, MatSnackBar } from "@angular/material";
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HealthOrganizationSetupDomain } from "src/app/core/model/v2/practice/HealthOrganizationSetupDomain";
import { WorkingHours } from '../../../core/model/v2/workinghours';
import { ViewChild } from '@angular/core';
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { WindowLoaderService } from '../window-loader/window-loader.service';
import { ServiceToOffer } from '../../../core/models/healthSystem/serviceToOffer';
import { CommonService } from '../../../core/services/v2/common.service';
import { HealthSystemAddress, PLocation, PractitionerServiceRequest, PServices, ServiceWorkingHours, SubCategory } from '../../../core/model/v2/practitioner/practitioner-service-request';
import { GlobalLocation } from '../../../core/model/v2/healthSystem/global-location';
import { Services } from '../../../core/model/v2/practice/Services';
import { PractitionerServices } from '../../../core/model/v2/practitioner/practitioner-services';
import { sub } from 'date-fns/esm';
import { debug } from 'console';
import { tr } from 'date-fns/esm/locale';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  @Input() practitionerId;
  SymptomData: Practitioner = new Practitioner();
  showAddServices: boolean = false;
  showServiceList: boolean = false;
  showEditService: boolean = false;
  isParams: boolean;
  healthsystemId: number;
  practicelocationData: GlobalHealthSystem;
  indexer: number;
  imageUrlTag: string;
  editServiceForm: FormGroup;
  HealthSystemWorkingArray = [];
  workingHrsObj: ServiceWorkingHours[];
  serviceUpdatedIndex: number;
  healthSystemAddressArr: HealthSystemAddress[] = [];
  healthSystemAddress = new HealthSystemAddress;
  serviceUpdateVariables = new PractitionerServiceRequest;
  selectedService = new PServices;
  @ViewChild('mySelect', { static: false }) mySelect;
  serviceTypes: ServiceToOffer[];
  subCategoryImages: string[] = [];
  serviceRequest = new PractitionerServiceRequest;
  healthOrganizationSetup: HealthOrganizationSetupDomain = new HealthOrganizationSetupDomain();
  selectedFile = null;
  subCategoryImageArray: string[] = [];
  currentUploadedImgUrl: string = "";
  imageUrl: string;
  subcategoryObj: SubCategory[];
  isNewBtnClicked: boolean = false;
  isUploadBtnClicked: boolean = false;
  plIndx: number;
  srIndx: number;
  patientId: number;
  constructor(private _route: ActivatedRoute,
    private commonService: CommonService,
    public dialog: MatDialog,
    private _loaderService: WindowLoaderService,
    private _practiceService: PracticeService,
    private _snackBar: MatSnackBar,
    private readonly changeDetector: ChangeDetectorRef,
    private fb: FormBuilder,) {
  }
  ngOnInit() {
    this.getParams();
    if (this.patientId > 0) {
      this.showAddServices = true;
      this.showEditService = false;
    }
    else {
      this.showAddServices = false;
    }
    this.subcategoryObj = [];
    this.getPracDetailsById(this.practitionerId);
    this.getServiceTypes();
    this.setHealthSystemId();
 
    this.getDetailsById(this.healthsystemId);
    this._practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (data) => {

        this.healthOrganizationSetup = data;
        this.healthSysteWorkingHrs();
      });
  }
  getParams() {
    this._route.params.subscribe(
      (params) => {
        this.patientId = params["patientId"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
  get workingHours() {
    return this.editServiceForm.get("workingHours") as FormArray;
  }
  get subCategoryArray() {
    return this.editServiceForm.get("subCategoryArray") as FormArray;
  }
  setTime(i) {
    let workingHrsArr = this.getWorkingHoursDetails();
    workingHrsArr.removeAt(i);
  }
  removeSubCategory(j) {

    let subCatArr = this.getSubCategoryDetails();
    subCatArr.removeAt(j);
  }
  addNewDay() {

    let workingHrsArr = this.editServiceForm.get('workingHours') as FormArray;
    let newWorkingHrsEntry = this.fb.group({
      day: '',
      timeFrom: '',
      timeTo: ''
    })
    workingHrsArr.push(newWorkingHrsEntry);
  }
  addNewSubCategory() {

    let subCatArr = this.editServiceForm.get('subCategoryArray') as FormArray;
    // let subImgArr = this.editServiceForm.get('imageArray') as FormArray;
    let newSubCatEntry = this.fb.group({
      subCategoryNameCtrl: '',
      shortSummaryCtrl: '',
      longDescriptionCtrl: '',
      imageArray: []
    })
    subCatArr.push(newSubCatEntry);
    let subCatObj = new SubCategory;
    subCatObj.longDescription = "";
    subCatObj.shortSummary = "";
    subCatObj.subCategoryName = "";
    subCatObj.subCategoryImages = [];
    this.selectedService.subcategory.push(subCatObj);
  }
  getWorkingHoursDetails(): FormArray {
    return this.editServiceForm.get('workingHours') as FormArray;
  }
  getSubCategoryDetails(): FormArray {
    return this.editServiceForm.get('subCategoryArray') as FormArray;
  }
  healthSysteWorkingHrs() {

    for (let i = 0; i < this.healthOrganizationSetup.healthSystems.length; i++) {
      this._practiceService.gethealthSystemDetails(this.healthOrganizationSetup.healthSystems[i].id).subscribe(
        (practicelocationData) => {

          this.HealthSystemWorkingArray[i] = { Name: this.healthOrganizationSetup.healthSystems[i].name, WorkingHrs: practicelocationData.workingHours };
        });
    }
  }
  formbuilding() {
    this.indexer = this.serviceRequest.location != undefined ? (this.serviceRequest.location.length - 1) + 1 : 0;
    this.editServiceForm = this.fb.group(
      {
        //treatmentFormControl: new FormControl(),
        serviceCategoryControl: new FormControl(''),
        serviceTypeFormControl: new FormControl(''),
        locationFormControl: new FormControl(''),
        workingHours: new FormArray([
          this.fb.group({
            day: new FormControl(''),
            timeFrom: new FormControl(''),
            timeTo: new FormControl('')
          })
        ]),
        subCategoryArray: new FormArray([
          this.fb.group({
            subCategoryNameCtrl: new FormControl(''),
            shortSummaryCtrl: new FormControl(''),
            longDescriptionCtrl: new FormControl(''),
            imageArray: new FormArray([
            ])
          })
        ])
      });

    //let lastIndexLoc: number = 0;
    //let lastIndexSrv: number = 0;
    //let ploc = new PLocation;
    //ploc.locationId = 0;
    //ploc.workingHrs = [];
    //ploc.glocation = null;
    //this.serviceRequest.location.push(ploc);
    //lastIndexLoc = this.serviceRequest.location.length;
    //this.serviceRequest.location[lastIndexLoc].glocation = null;

    //let pServ = new PServices;
    //pServ.serviceId = this.selectedService.serviceId;
    //pServ.serviceName = this.editServiceForm.value.serviceCategoryControl;
    //pServ.serviceType = this.editServiceForm.value.serviceTypeFormControl;
    //pServ.subcategory = [];
    //this.serviceRequest.location[lastIndexLoc].services.push(pServ);
    //lastIndexSrv = this.serviceRequest.location[lastIndexLoc].services.length;


    let subCat = new SubCategory();
    subCat.longDescription = "";
    subCat.shortSummary = "";
    subCat.subCategoryName = "";
    subCat.subCategoryImages = [];

    //this.serviceRequest.location[lastIndexLoc].services[lastIndexSrv].subcategory.push(subCat);
    // this.selectedService.subcategory.push(subCat);

    this.selectedService = {
      serviceId: 0,
      serviceType: "",
      serviceName: "",
      subcategory: [],
      workingHrs: []
    };
    this.selectedService.subcategory.push(subCat);
  }

  setHealthSystemId() {
    this._route.params.subscribe(
      (params) => {

        this.isParams = params["id"];

        this.healthsystemId = params["hsid"] != undefined ? params["hsid"]: +params["id"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
  showAddServicePage() {
    this.showAddServices = true;
    this.showServiceList = false;
    this.showEditService = false;
  }

  hideAddServicePage() {
    this.showAddServices = false;
  }

  showServiceListPage() {
    this.isNewBtnClicked = false;
    this.showServiceList = true;
    this.showAddServices = false;
    this.showEditService = false;
  }
  addNewService() {
    this.isNewBtnClicked = true;
    this.showEditService = true;
    this.showAddServices = false;
    this.showServiceList = false;
    this.formbuilding();

  }

  showEditServicePage(i?: number, pService?: PServices, s?: number) {
   
    this.showEditService = true;
    this.showAddServices = false;
    this.showServiceList = false;
    this.indexer = i;
    this.serviceUpdatedIndex = s;
    this.selectedService = pService;

    if (i != undefined) {
      this.editServiceForm = this.fb.group({
        serviceCategoryControl: new FormControl(
          pService.serviceName ? pService.serviceName : ""
        ),
        serviceTypeFormControl: new FormControl(

          pService.serviceType ? pService.serviceType : ""
        ),
        locationFormControl: new FormControl(
          this.serviceRequest ?
            (this.healthSystemAddressArr.find(x => x.id == this.serviceRequest.location[i].locationId) ?
              this.healthSystemAddressArr.find(x => x.id == this.serviceRequest.location[i].locationId):0): 0
        ),
        workingHours: this.fb.array(
          this.serviceRequest
            ? this.serviceRequest.location[i].services[s].workingHrs.map((workings) => {
              return this.fb.group({
                day: workings.Day,
                timeFrom:
                  (workings.Hours[0] != "Closed")
                    ? workings.Hours[0].split("-")[0].trim()
                    : "",
                timeTo:
                  (workings.Hours[0] != "Closed")
                    ? workings.Hours[0].split("-")[1].trim()
                    : "",
                isClosed: workings.Hours[0] == "" ? false : false,
              });
            })
            : null
        ),
        subCategoryArray: this.fb.array(pService.subcategory ?
          pService.subcategory.map((subcategories) => {
            return this.fb.group({
              subCategoryNameCtrl: subcategories.subCategoryName,
              shortSummaryCtrl: subcategories.shortSummary,
              longDescriptionCtrl: subcategories.longDescription,
              imageArray: this.fb.array(
                subcategories.subCategoryImages ?
                  (subcategories.subCategoryImages)
                  : []
              )
            });
          })
          : null
        )


      })
    }
  }


  optionClicked(addresId: any) {
    if (this.isNewBtnClicked != true && this.checkLocationExists(addresId)) {
      //let curLocObj = this.serviceRequest.location.find(x => x.locationId = addresId);
      //let curLodId = curLocObj!=undefined?curLocObj.locationId:0;
     // if (addresId != curLodId) {
      this.editServiceForm.controls.locationFormControl.setValue(this.serviceRequest.location[this.indexer].locationId);
        this._snackBar.open("Location already exists!", "Ok", {
          duration: 5000
        })
     // }
      return false;
    }
    if (this.selectedService.serviceId==undefined || this.selectedService.serviceId == 0) {
      this._snackBar.open("Please select a service!", "Ok", {
        duration: 5000
      })
      return false;
    }
    if (this.checkSeriviceExists(addresId, this.selectedService.serviceId)) {
      this.editServiceForm.controls.serviceCategoryControl.setValue("");
      this._snackBar.open("Service already exists in the selected location!", "Ok", {
        duration: 5000
      })
      return false;
    }
  }
  async getServiceTypes() {
    await this.commonService.getServicesToOffer().subscribe((res) => {
      this.serviceTypes = res.result;
      console.warn("services-------", this.serviceTypes)
    });
  }
  async getPracDetailsById(practitionerId: number, event?, subCatIndx?: number) {
    let that = this;
    that._loaderService.show();
    await that._practiceService.getPractitionerDetails(practitionerId).subscribe(
      (practitionerData) => {
        that.SymptomData = practitionerData;
        that.SymptomData.healthSystems.forEach(x => {
          that.healthSystemAddress = new HealthSystemAddress();
          that.healthSystemAddress.id = x.location.id;
          that.healthSystemAddress.address = (x.location.address1 + " " + x.location.city + " " + x.location.state + " " + x.location.zipCode);
          that.healthSystemAddressArr.push(that.healthSystemAddress);
        })
        console.log(that.healthSystemAddressArr);
        that.changeDetector.detectChanges();
        that.getServicesByPid(that.practitionerId);
      },
      (error) => {
        console.error(error);
        that._loaderService.hide();
      },
      () => {
        that._loaderService.hide();
      }
    );
  }
  async getServicesByPid(practitionerId: number, event?, subCatIndx?: number) {

    this._loaderService.show();
    await this._practiceService.getPractitionerServicesByPractitionerId(practitionerId).subscribe(
      (practitionerData) => {

        if (practitionerData && practitionerData != undefined) {
          this.serviceRequest = JSON.parse(practitionerData.serviceData);
          //let currentLocation = this.serviceRequest.location.filter(x => x.locationId == 123);
          if (this.serviceRequest.location != undefined) {
            this.serviceRequest.location.forEach(x => {
              let loc = this.SymptomData.healthSystems.find(y => y.location.id == x.locationId);
              if (loc != undefined && loc.location != undefined) {
                x.glocation = loc.location;
              }

            });
          }
          //  this.uploadProcess(event, subCatIndx);
          this.changeDetector.detectChanges();
        }
      });
  }
  getDetailsById(healthsystemId: number) {

    this._practiceService.gethealthSystemDetails(healthsystemId).subscribe(
      (practicelocationData) => {
        this.practicelocationData = practicelocationData;
        this._practiceService.gethealthSystemServices(this.healthsystemId).subscribe(
          (list) => {
            if (list.resultStatus.isSuccess) {

              this.practicelocationData.healthSystemServices = list.result;
              this.changeDetector.detectChanges();
            } else {
              console.error(list);
              this._snackBar.open(
                `Error when retrieving services list: ${list.resultStatus.message}`,
                "Ok"
              );
            }
          },
          (error) => {
            console.error(error);
            this._snackBar.open(
              `Services could not be retrieved${error.error && error.error.resultStatus
                ? ": " + error.error.resultStatus.message
                : ""
              }`,
              "Ok",
              {
                duration: 5000,
              }
            );
          }
        );
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onServiceChange(item: any) {
  
    let ServiceId = this.serviceTypes.find(x => x.name == item).id;


    this.selectedService.serviceId = ServiceId;

  }
  onSubmitService(editPForm: FormGroup, event?: any, subCatIndx?: number) {
    if (this.editServiceForm.value.serviceCategoryControl == "") {
      this._snackBar.open("Please select a service!", "Ok", {
        duration: 5000
      });
      return false;
    }
    if (this.editServiceForm.value.locationFormControl == "") {
      this._snackBar.open("Please select a location!", "Ok", {
        duration: 5000
      });
      return false;
    }
    let workinghour: ServiceWorkingHours[] = this.editServiceForm.value.workingHours.map((wh) => {
      return {
        Day: wh.day,
        Hours: [wh.isClosed ? "" : wh.timeFrom + "-" + wh.timeTo],
      };
    });
    this.subcategoryObj = this.editServiceForm.value.subCategoryArray.map((subcat) => {
      return {
        subCategoryName: subcat.subCategoryNameCtrl,
        shortSummary: subcat.shortSummaryCtrl,
        longDescription: subcat.longDescriptionCtrl,
        subCategoryImages: subcat.imageArray == null ? [] : subcat.imageArray
      };
    });
    let serv = new PServices;
    if (this.isNewBtnClicked == true) {
      if (this.serviceRequest.location == undefined) {
        this.serviceRequest.location = [];
      }
      serv.serviceId = this.selectedService.serviceId;
      serv.serviceName = this.editServiceForm.value.serviceCategoryControl;
      serv.serviceType = this.editServiceForm.value.serviceTypeFormControl;
      serv.subcategory = this.subcategoryObj;
      serv.workingHrs = workinghour;
      let pl = this.serviceRequest.location.find(x => x.locationId == this.editServiceForm.value.locationFormControl);
      if (pl != undefined && pl != null) {
        this.plIndx = this.serviceRequest.location.indexOf(pl);
        if (this.plIndx != -1) {
          this.indexer = this.plIndx;
        }
        let sr = pl.services.find(x => x.serviceId == this.selectedService.serviceId);
        if (sr != undefined && sr != null) {
          this.srIndx = pl.services.indexOf(sr);
          this.serviceRequest.location[this.plIndx].services[this.srIndx] = serv;
        }
        else {
          this.serviceRequest.location[this.plIndx].services.push({
            subcategory: serv.subcategory, serviceId: serv.serviceId, serviceName: serv.serviceName, serviceType: serv.serviceType, workingHrs: workinghour
          })
          this.srIndx = this.serviceRequest.location[this.plIndx].services.findIndex(x => x.serviceId == serv.serviceId);
        }
      }
      else {
        this.serviceRequest.location.push({
          locationId: this.editServiceForm.value.locationFormControl,
          glocation: null,
          services: [serv]
        });
        this.srIndx = 0;

      }
      this.serviceUpdatedIndex = this.srIndx;
    }
    else {
      this.serviceRequest.location[this.indexer].locationId = this.editServiceForm.value.locationFormControl;
      this.serviceRequest.location[this.indexer].services[this.serviceUpdatedIndex].serviceId = this.selectedService.serviceId;
      this.serviceRequest.location[this.indexer].services[this.serviceUpdatedIndex].serviceName = this.editServiceForm.value.serviceCategoryControl;
      this.serviceRequest.location[this.indexer].services[this.serviceUpdatedIndex].serviceType = this.editServiceForm.value.serviceTypeFormControl;
      this.serviceRequest.location[this.indexer].services[this.serviceUpdatedIndex].subcategory = this.subcategoryObj;
      this.serviceRequest.location[this.indexer].services[this.serviceUpdatedIndex].workingHrs = workinghour;
    }
    this.serviceRequest.practitionerId = this.SymptomData.id;

    const serviceUpdateBody = new PractitionerServices();
    serviceUpdateBody.id = 0;
    serviceUpdateBody.practitionerId = this.SymptomData.id;
    serviceUpdateBody.serviceData = JSON.stringify(this.serviceRequest);
    serviceUpdateBody.active = true;
    let that = this;
    that._loaderService.show();
    that._practiceService.addOrUpdateServices(serviceUpdateBody).subscribe(
      (res) => {
        if (res.isSuccess = true) {
          that.getPracDetailsById(this.practitionerId);
          if (!that.isNewBtnClicked && !that.isUploadBtnClicked) {
            that.showServiceListPage();
          }
          else {
            that.isUploadBtnClicked = false;
            if (that.isNewBtnClicked == true) {
              that.showEditServicePage(that.indexer, serv, that.srIndx);
            }
            else {
              that.showEditServicePage(that.indexer, that.selectedService, that.serviceUpdatedIndex);
            }

            //this.uploadProcess(event, subCatIndx);
          }
          that.changeDetector.detectChanges();
        }
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      }
    );
    this._loaderService.hide();
  }

  uploadFile(event, subCatIndex: number) {
    if (event == undefined) {
      return false;
    }
    //if (this.isNewBtnClicked) {
    //  this.onSubmitService(this.editServiceForm, event, subCatIndex);

    //}
    //else {
    //  this.uploadProcess(event, subCatIndex);

    //}
    this.uploadProcess(event, subCatIndex);

    event = null;
  }

  uploadProcess(event: any, subCatIndex: number) {
    if (event == undefined) {
      return false;
    }
    this.isUploadBtnClicked = true;
    this.selectedFile = event.target.files[0];
    const payload: FormData = new FormData();
    payload.append('PractitionerId', this.practitionerId.toString());
    payload.append('ImageSource', this.selectedFile);
    let fsize = this.selectedFile.size;
    let sizeInKB: number = fsize / 1000;
    if (sizeInKB >= 10000) {
      this._snackBar.open("File size cannot exceed 10 MB", "Ok", {
        duration: 5000
      });
      event.target = "";
      return false;
    }
    const self = this;
    self.currentUploadedImgUrl = "";
    self._practiceService.uploadtPractitionerServicePicture(payload).subscribe(
      (res) => {
        if (res.resultStatus.isSuccess) {
          var resp = res;
          console.log("Image URL is :" + res.imageUrl);
          if (self.editServiceForm.value.subCategoryArray[subCatIndex].imageArray == null) {
            self.editServiceForm.value.subCategoryArray[subCatIndex].imageArray = [];
          }
          self.editServiceForm.value.subCategoryArray[subCatIndex].imageArray.push(res.imageUrl);
          console.log(self.editServiceForm.value.subCategoryArray[subCatIndex].imageArray);
          if (self.selectedService.subcategory[subCatIndex].subCategoryImages == null || self.selectedService.subcategory[subCatIndex].subCategoryImages == undefined) {
            self.selectedService.subcategory[subCatIndex].subCategoryImages = [];
          }
          self.selectedService.subcategory[subCatIndex].subCategoryImages.push(res.imageUrl);
          //self.showEditServicePage(self.indexer, self.selectedService, self.serviceUpdatedIndex);
          self.onSubmitService(self.editServiceForm, event, subCatIndex);
          self.changeDetector.detectChanges();
        }
      },
      (error) => { console.error(error); }
    );
  }

  deleteImage(k: number, subCatIndex: number) {

    this.selectedService.subcategory[subCatIndex].subCategoryImages.splice(k, 1);
    this.editServiceForm.value.subCategoryArray[subCatIndex].imageArray.splice(k, 1);
    this.showEditServicePage(this.indexer, this.selectedService, this.serviceUpdatedIndex);
    this.changeDetector.detectChanges();
  }

  deleteService(i: number, editPForm: FormGroup, s: number) {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: "400px",
      height: "268px",
      data: { entryId: i, confirmTitle: "Remove Service", confirmDescription: "Are you sure you want to delete this service?", noButtonTitle: "No", yesButtonTitle: "Yes" }

    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result != undefined) {
          console.log("Delete was successfull.")
          if (this.serviceRequest.location[i].services.length == 1) {
            this.serviceRequest.location[i].services.splice(s, 1);
            this.serviceRequest.location.splice(i, 1);
          }
          else {
            this.serviceRequest.location[i].services.splice(s, 1);
          }


          const serviceUpdateBody = new PractitionerServices();
          serviceUpdateBody.id = 0;
          serviceUpdateBody.practitionerId = this.SymptomData.id;
          serviceUpdateBody.serviceData = JSON.stringify(this.serviceRequest);
          serviceUpdateBody.active = true;
          this._loaderService.show();
          this._practiceService.addOrUpdateServices(serviceUpdateBody).subscribe(
            (res) => {
              if (res.isSuccess = true) {
              }
              this._loaderService.hide();

              this.changeDetector.detectChanges();
            },
            (error) => {
              console.error(error);
              this._loaderService.hide();
            }
          );
          this._snackBar.open("Service successfully deleted!", "Ok", {
            duration: 5000
          });
        }
      },
      (error) => { console.error(error); });



  }

  checkFileType(purl: string) {
    const images = ["jpg", "gif", "png", "svg", "bmp", "tiff", "psd"]
    const videos = ["mp4", "3gp", "ogg", "wmv", "avi", "mov", "gif"]
    const url = new URL(purl)
    const extension = url.pathname.split(".")[1]
    if (images.includes(extension)) {
      return false
    } else if (videos.includes(extension)) {
      return true;
    }
  }
  onSave(editPForm: FormGroup, event?: any, subCatIndx?: number) {
    this.onSubmitService(editPForm);
    this.isNewBtnClicked = false;
  }

  checkSeriviceExists(locId: number, srvId: number) {
    let isServiceFound: boolean = false;
    let locObj = this.serviceRequest.location.find(x => x.locationId == locId);
    if (locObj != undefined) {
      let srvObj = locObj.services.find(x => x.serviceId == srvId);
      if (srvObj != undefined) {
        isServiceFound = true;
      }
    }
    return isServiceFound;
  }
  checkLocationExists(locId: number) {
    let isLocationFound: boolean = false;
    let locObj = this.serviceRequest.location.find(x => x.locationId == locId);
    if (locObj != undefined) {
      isLocationFound = true;
    }
    return isLocationFound;
  }
}
